export const getArrFromParas = (str) => {
  return str
    .replace(/\n/g, "\r") // turn all \n into \r
    .split(/\r+/) // Turn into an array by splitting on grouping of \r
}
